export default "__VITE_ASSET__DJbYOb1H__"